module.exports = __webpack_public_path__ + "static/media/transgender-alt.af120b98.svg";